/** New dashboard strings (merged on top of the original en dictionary). */
export const extraEn = {
  common: {
    close: 'Close',
    show: 'Show',
    hide: 'Hide',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    keep: 'Keep',
    yes: 'Yes',
    back: 'Back',
    dismiss: 'Dismiss',
    edit: 'Edit',
    undo: 'Undo',
    prev: '← Prev',
    next: 'Next →',
    pageOf: '{{page}} / {{count}}',
    showing: 'Showing {{from}}–{{to}} of {{total}}',
    exportCsv: 'Export CSV',
    importing: 'Importing…',
    saving: 'Saving…',
    creating: 'Creating…',
    on: 'On',
    off: 'Off',
    active: 'Active',
    inactive: 'Inactive',
    hidden: 'Hidden',
    never: 'Never',
    all: 'All',
    unknown: 'Unknown',
    noMatches: 'No matches',
    include: 'Include',
    exclude: 'Exclude',
    selectAll: 'Select all',
    clear: 'Clear',
    filterMode: 'Filter mode',
    actions: 'Actions',
    confirmDelete: 'Confirm delete',
    newPassword: 'New password',
    countryCode: 'Country code',
    emptyDash: '—',
    dateRange: {
      ariaLabel: 'Date range',
      from: 'From',
      to: 'To',
      today: 'Today',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisYear: 'This year',
      allTime: 'All time',
      custom: 'Custom',
    },
  },
  nav: {
    groups: {
      insights: 'Insights',
      books: 'Accounting',
      operations: 'Operations',
      management: 'Management',
      crm: 'CRM',
      system: 'System',
      admin: 'Admin',
    },
    language: 'Language',
    openMenu: 'Open menu',
    themeLight: 'Switch to light mode',
    themeDark: 'Switch to dark mode',
    books: 'Books',
    role: {
      owner: 'owner',
      admin: 'admin',
      manager: 'manager',
      accountant: 'accountant',
      super_admin: 'super admin',
      anon: 'anon',
    },
  },
  auth: {
    createAccount: 'Create account',
    accountCreated: 'Account created. You can sign in now.',
    needAccount: 'Need an account? Sign up',
    haveAccount: 'Have an account? Sign in',
    notConfiguredBody:
      'Create a Supabase project, then copy apps/dashboard/.env.example to apps/dashboard/.env and set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY. Restart the dev server.',
    noRoleBodyExtended:
      'This account has no role yet. Ask a super admin to provision it, or run the super-admin bootstrap SQL.',
  },
  wasteReasons: {
    expired: 'Expired',
    spoiled: 'Spoiled',
    quality_issue: 'Quality issue',
    non_saleable: 'Non-saleable',
    prep_waste: 'Preparation waste',
    burnt: 'Burnt',
    spillage: 'Spillage',
    damaged: 'Damaged',
    staff_meal: 'Staff meal',
    other: 'Other',
  },
  landing: {
    signIn: 'Sign in',
    lead: 'Café POS for Armenian cafés.',
    downloads: {
      'macos-arm64': 'Mac (Apple silicon)',
      'macos-x64': 'Mac (Intel)',
      'windows-x64': 'Windows',
    },
  },
  dashboard: {
    title: 'Dashboard',
    loading: 'Loading dashboard…',
    loadFailed: 'Load failed',
    couldntLoad: "Couldn't load the dashboard",
    revenueToday: 'Revenue today',
    ordersToday: 'Orders today',
    averageOrder: 'Average order',
    coversToday: 'Covers today',
    givenAwayToday: 'Given away today',
    tipsToday: 'Card tips',
    staffToday: 'Staff today',
    staffWage: 'Wage',
    staffTodayEmpty: 'No one on the timesheet today.',
    bookingsToday: 'Bookings today',
    bookingsInHouse: 'In house',
    bookingsArriving: 'Arriving',
    bookingsLeaving: 'Leaving',
    bookingsPending: 'Pending',
    categoryShare: 'Today by category',
    noCategorySales: 'No sales today.',
    uncategorised: 'Uncategorised',
    vsYesterday: 'vs yesterday',
    revenueChart: 'Revenue',
    last30: 'Last 30 days',
    paymentSplit: 'Payment split',
    noPayments30: 'No payments in the last 30 days.',
    cash: 'Cash',
    card: 'Card',
    ordersByHour: 'Orders by hour',
    last7: 'Last 7 days',
    orders: 'Orders',
    topProducts: 'Top products',
    topProductsCaption: 'Last 30 days by revenue',
    noSales30: 'No sales in the last 30 days.',
    stockIn: 'Stock in',
    lowStock: 'Low stock',
    lowStockCaption: '{{count}} ingredient(s) at or below threshold',
    lowStockNegative: ' · {{count}} negative',
    prep: 'Prep',
    threshold: 'Threshold {{value}}',
  },
  sales: {
    title: 'Sales',
    subtitleRange: '{{from}} – {{to}} · {{comparison}}',
    tabRevenue: 'Revenue',
    tabOrders: 'Orders',
    loadFailed: 'Load failed',
    couldntLoad: "Couldn't load sales",
    vsYesterday: 'vs yesterday',
    vsPrevious7: 'vs previous 7 days',
    vsPrevious30: 'vs previous 30 days',
    vsPrevious90: 'vs previous 90 days',
    vsMonthBefore: 'vs the month before',
    vsSameSpanLastYear: 'vs the same span last year',
    vsPreviousPeriod: 'vs previous period',
    revenue: 'Revenue',
    paidOrders: 'Paid orders',
    averageOrder: 'Average order',
    covers: 'Covers',
    revenuePerCover: 'Revenue per cover',
    cardTips: 'Card tips',
    tipRateOnCard: 'Tip rate on card orders',
    averageTipWhenTipped: 'Average tip when tipped',
    note: 'Revenue and average order are goods only; card tips are tracked separately. Payment split includes tips in card totals.',
    revenueTrend: 'Revenue trend',
    byHour: 'By hour',
    byDay: 'By day',
    paymentSplit: 'Payment split',
    noPaymentData: 'No payment data.',
    cash: 'Cash',
    card: 'Card',
    forceCloseByReason: 'Force-close by reason',
    noForceClosed: 'No force-closed orders in this period.',
    reasonMistake: 'mistake',
    reasonSystemError: 'system error',
    reasonFree: 'free',
    reasonOther: 'other',
    allOrders: 'All orders',
    paid: 'Paid',
    refunded: 'Refunded',
    void: 'Void',
    forceClosed: 'Force-closed',
    refundRate: 'Refund rate',
    forceCloseRate: 'Force-close rate',
    orderQuality: 'Order quality',
    avgItems: 'Avg items per order',
    modifierAttach: 'Modifier attach rate',
    paidShare: 'Paid orders share',
    totalCovers: 'Total covers',
  },
  orders: {
    title: 'Orders',
    subtitleFiltered: '{{filtered}} of {{total}}',
    subtitleTotal: '{{amount}} total',
    subtitlePaid: '({{amount}} paid)',
    live: '● Live',
    liveUpdates: 'Live updates',
    closeReason: 'Close reason',
    compType: 'Comp type',
    compRecipient: 'Comp recipient',
    reprint: 'Reprint',
    reprintTitle: 'Reprint receipt',
    searchPlaceholder: 'Search by #, ID, TIN…',
    allStatuses: 'All statuses',
    statusOpen: 'open',
    statusPaid: 'paid',
    statusVoid: 'void',
    statusRefunded: 'refunded',
    paymentUnpaid: 'unpaid',
    paymentPartial: 'partial',
    allCompTypes: 'All comp types',
    allRecipients: 'All recipients',
    menuItems: 'Menu items',
    searchMenu: 'Search menu…',
    inactiveSuffix: ' (inactive)',
    paymentType: 'Payment type',
    all: 'All',
    cash: 'Cash',
    card: 'Card',
    shiftId: 'Shift ID',
    clearShift: 'Clear shift filter',
    forcedOnly: 'Force-closed only',
    missingPayments: '{{count}} paid order(s) missing payment row',
    colNumber: '#',
    colTime: 'Time',
    colStatus: 'Status',
    colPayment: 'Payment',
    colTotal: 'Total',
    colCashierShift: 'Cashier / Shift',
    colTin: 'TIN',
    colComp: 'Comp',
    colForced: 'Forced',
    missing: 'missing',
    missingTitle: 'No payment row recorded for this order',
    pay: 'pay',
    payMismatch: 'Payment {{paid}} ≠ expected {{expected}} (due {{due}})',
    payMismatchTip: 'Payment {{paid}} ≠ expected {{expected}} (due {{due}} + tip {{tip}})',
    fiscal: 'fiscal',
    fiscalMismatch: 'Charged {{charged}} but fiscal receipt shows {{fiscal}}',
    inclLoyalty: 'incl. −{{amount}} loyalty',
    plusTip: '+ {{amount}} tip',
    goToShift: 'Go to this shift',
    empty: 'No orders match these filters.',
    detailTitle: 'Order #{{number}}',
    cashier: 'Cashier',
    closedBy: 'Closed by',
    shift: 'Shift',
    openShift: 'Open shift',
    forceClosed: 'Force closed',
    noReason: 'no reason',
    unknownRecipient: 'Unknown',
    loyalty: 'Loyalty',
    member: 'Member',
    removedMember: 'Removed member',
    discount: 'Discount',
    pointsRedeemed: 'Points redeemed',
    totals: 'Totals',
    itemsSubtotal: 'Items subtotal',
    loyaltyDiscount: 'Loyalty discount',
    amountDue: 'Amount due',
    cardTip: 'Card tip',
    charged: 'Charged',
    items: 'Items',
    colName: 'Name',
    colQty: 'Qty',
    colUnitPrice: 'Unit price',
    colDiscount: 'Discount',
    colLineTotal: 'Line total',
    noItems: 'No items on this order.',
    payments: 'Payments',
    colMethod: 'Method',
    colAmount: 'Amount',
    noPayments: 'No payments recorded.',
    fiscalTitle: 'Fiscal receipt',
    fiscalMatches: 'Fiscal total {{fiscal}} matches charged {{charged}}.',
    fiscalMismatchTitle: 'Fiscal mismatch',
    fiscalMismatchBody:
      'charged {{charged}} but HDM fiscal receipt shows {{fiscal}} ({{gap}} on receipt). The printed fiscal total may not match what was collected.',
    fiscalNumber: 'Fiscal #',
    fiscalTotal: 'Fiscal total',
    change: 'Change',
    csvNumber: 'number',
    csvCreated: 'created_at',
    csvStatus: 'status',
    csvPayment: 'payment_status',
    csvTotal: 'total',
    csvForced: 'forced_close',
    csvCloseReason: 'close_reason',
    csvCompType: 'comp_type',
    csvCompRecipient: 'comp_recipient',
    csvTin: 'partner_tin',
    csvShift: 'shift_id',
    csvId: 'id',
  },
  shifts: {
    title: 'Shifts',
    subtitle: '{{count}} shifts',
    paymentMethod: 'Payment method',
    all: 'All',
    cash: 'Cash',
    card: 'Card',
    overallTotal: 'Overall total',
    cashTotal: 'Cash total',
    cardTotal: 'Card total',
    empty: 'No shifts in this period.',
    colOpened: 'Opened',
    colClosed: 'Closed',
    colCashier: 'Cashier',
    colOrders: 'Orders',
    colVoid: 'Void',
    colForced: 'Forced',
    colTotal: 'Total',
    colCash: 'Cash',
    colCard: 'Card',
    colStatus: 'Status',
    showBreakdown: 'Show breakdown',
    statusOpen: 'open',
    statusClosed: 'closed',
    shiftId: 'Shift ID',
    openingFloat: 'Opening float',
    paidOrders: 'Paid orders',
    paidOf: '{{paid}} of {{total}}',
    viewOrders: 'View orders →',
    reassign: 'Reassign cashier',
    selectCashier: '— select cashier —',
    cashierHdm: ' (HDM #{{no}})',
    cashierNoHdm: ' · no HDM no',
    reassignNoHdm: 'Selected cashier has no HDM number — set one first in Cashiers.',
    paymentBreakdown: 'Payment breakdown',
    noPayments: 'No payments recorded.',
    colMethod: 'Method',
    grandTotal: 'Grand total',
    unrecorded: '{{amount}} unrecorded — payment rows missing for some orders. Order-based total: {{orderTotal}}',
    expenses: 'Expenses / Cash paid out',
    noExpenses: 'No expenses recorded.',
    colCategory: 'Category',
    colDescription: 'Description',
    colAddedBy: 'Added by',
    colAmount: 'Amount',
    total: 'Total',
    addExpense: '+ Add expense',
    amountAmd: 'Amount (AMD)',
    descriptionPlaceholder: 'e.g. night taxi for staff',
    errorPositive: 'Enter a positive amount.',
    errorDescription: 'Description is required.',
    catTaxi: 'taxi',
    catSupplies: 'supplies',
    catMeals: 'meals',
    catDelivery: 'delivery',
    catOther: 'other',
    expectedCash: 'Expected cash in drawer',
    expectedFormula: '{{cashSales}} cash sales − {{expenses}} expenses = {{result}}',
  },
  cashDrops: {
    title: 'Cash drops',
    subtitle: 'End-of-day cash to collect · owner/admin only',
    refreshExpected: 'Refresh expected amounts',
    syncing: 'Syncing…',
    markCollected: 'Mark collected',
    waiting: '{{count}} drop(s) waiting',
    expectedTotal: 'Expected total: {{amount}}',
    syncFailed: 'Sync failed',
    invalidCounted: 'Enter a valid counted amount.',
    colDay: 'Day',
    colExpected: 'Expected',
    colCounted: 'Counted',
    colStatus: 'Status',
    colCollected: 'Collected',
    colCollectedBy: 'Collected by',
    showExpenses: 'Show expenses',
    hideExpenses: 'Hide expenses',
    expenseSummary: '{{count}} expense(s) · −{{amount}}',
    pending: 'Pending',
    collected: 'Collected',
    empty: 'No cash drops yet. Click “Refresh expected amounts” to generate from cash sales.',
    cashSales: 'Cash sales',
    expenses: 'Expenses',
    expected: 'Expected',
    colTime: 'Time',
    colCategory: 'Category',
    colDescription: 'Description',
    colBy: 'By',
    colAmount: 'Amount',
    catTaxi: 'Taxi',
    catSupplies: 'Supplies',
    catMeals: 'Meals',
    catDelivery: 'Delivery',
    catOther: 'Other',
    collectTitle: 'Collect drop — {{day}}',
    expectedLabel: 'Expected: {{amount}}',
    countedLabel: 'Counted amount (֏)',
    noteLabel: 'Note (optional)',
    confirm: 'Confirm collected',
  },
  inventoryInsights: {
    title: 'Inventory',
    subtitle: 'Loss, stock health, movements and flow',
    tabLoss: 'Loss & variance',
    tabStock: 'Stock health',
    tabTransactions: 'Transactions',
    tabFlow: 'Stock flow',
    loadFailed: 'Load failed',
    notConfigured: 'Not configured',
    couldntLoad: "Couldn't load inventory",
    stockOverview: 'Stock overview',
    totalCount: '{{count}} total',
    lowCount: '{{count}} low',
    criticalCount: '{{count}} critical',
    searchIngredient: 'Search ingredient…',
    colIngredient: 'Ingredient',
    colStock: 'Stock',
    colThreshold: 'Threshold',
    colStatus: 'Status',
    statusOk: 'OK',
    statusLow: 'Low',
    statusCritical: 'Critical',
    noResults: 'No results',
    mostDepleted: 'Most depleted (all time)',
    depleted: 'Depleted',
    txLog: 'Transaction log ({{count}} entries)',
    typeSale: 'Sale',
    typeRestock: 'Restock',
    typeAdjustment: 'Adjustment',
    typeWaste: 'Waste',
    typeStockCount: 'Stock count',
    typeCountRevert: 'Count revert',
    typeWasteRevert: 'Waste cancel',
    typeInvoice: 'Invoice',
    typeInvoiceRevert: 'Invoice revert',
    typePrep: 'Prep',
    typeForceClose: 'Force close',
    colDate: 'Date',
    colType: 'Type',
    colDelta: 'Delta',
    colNote: 'Note',
    noTransactions: 'No transactions',
    colStockIn: 'Stock In',
    colStockOut: 'Stock Out',
    colNet: 'Net',
    selectRange: 'Select a date range above.',
    noTxPeriod: 'No transactions in this period.',
    allIngredients: 'All ingredients',
    categoryAll: 'All',
    categoryWaste: 'Waste',
    categoryUnknown: 'Unknown',
    lossRate: 'Loss rate',
    netLoss: 'Net {{pct}}% · −{{amount}}',
    formula: '(Waste + Unknown ↓) ÷ Stock in value',
    benchmark: 'Target: under 2–5% of purchases · Stock in {{amount}}',
    waste: 'Waste',
    unknownDown: 'Unknown ↓',
    unknownUp: 'Unknown ↑',
    ofStockIn: '{{pct}}% of stock in',
    recovered: 'Recovered via counts',
    periodFlow: 'Period flow (value)',
    stockIn: 'Stock in',
    dailyTrend: 'Daily loss trend',
    trendLegend: 'Bars: loss value · Line: % of stock in',
    noLoss: 'No loss events in this period.',
    topLoss: 'Top loss items',
    byValueAll: 'By value · waste + unknown ↓',
    byValueWaste: 'By value · waste only',
    byValueUnknown: 'By value · unknown ↓ only',
    noLossItems: 'No loss items in this period.',
    noLoggedWaste: 'No logged waste in this period.',
    noUnknown: 'No unknown variances in this period.',
    wasteByReason: 'Waste by reason',
    wasteOnly: 'Logged waste only',
    wasteFilterOff: 'Waste filter not active',
    selectWasteOrAll: 'Select Waste or All to see reasons.',
    vsDown: 'Stock in vs variance down',
    vsUp: 'Stock in vs variance up',
    modeQty: 'Quantity',
    modeValue: 'Value',
    mixedUnits: 'Mixed units — filter by ingredient to label quantities.',
    noDataPeriod: 'No data in this period.',
    varianceDown: 'Variance down',
    varianceUp: 'Variance up',
    lossEvents: 'Loss events',
    wasteEvents: 'Waste events',
    unknownEvents: 'Unknown variance events',
    colWhen: 'When',
    colCategory: 'Category',
    colValue: 'Value',
    colDetails: 'Details',
    catWaste: 'Waste',
    catUnknown: 'Unknown',
    catReverted: 'Reverted',
    noLossData: 'No loss data in this period.',
    netLossLabel: 'Net loss',
    varianceRatio: '{{label}} = {{pct}}% of stock in',
    stockInPct: 'Stock in {{pct}}%',
    compareAria: 'Stock in {{stockPct}}%, {{label}} {{varPct}}%',
    tooltipWaste: 'Waste: −{{amount}}',
    tooltipUnknownDown: 'Unknown ↓: −{{amount}}',
    tooltipTotalLoss: 'Total loss: −{{amount}}',
    tooltipLossRate: 'Loss rate: {{pct}}% of stock in',
    wasteAmount: 'Waste −{{amount}}',
    unknownAmount: 'Unknown −{{amount}}',
    wasSystemCounted: 'Was system {{system}} → counted {{counted}} {{unit}}',
    systemCounted: 'System {{system}} → counted {{counted}} {{unit}}',
  },
  menuInsights: {
    title: 'Menu insights',
    subtitle: 'What sells, what earns, and what to fix',
    tabProducts: 'Products',
    tabCategories: 'Categories',
    loadFailed: 'Load failed',
    notConfigured: 'Not configured',
    couldntLoad: "Couldn't load menu insights",
    vatTaxable: 'VAT taxable',
    vatExempt: 'VAT exempt',
    turnoverTax: 'Turnover tax',
    uncategorised: 'Uncategorised',
    unknownDept: 'Unknown',
    deptPrefix: 'Dept {{id}}',
    dailyByItem: 'Daily sales by item',
    dailyByCategory: 'Daily sales by category',
    noSales: 'No sales data for this period.',
    selectItem: 'Select at least one item to show the chart.',
    include: 'Include',
    includeCount: '{{selected}} / {{total}} included',
    chartTotal: 'Total: {{amount}} · {{count}} series included',
    filterAll: 'All',
    filterNone: 'None',
    noMatches: 'No matches',
    modeRevenue: 'Revenue',
    modeQuantity: 'Quantity',
    pctOfDay: '{{pct}}% of day',
    topProducts: 'Top products',
    byRevenue: 'By revenue',
    byQty: 'By qty',
    bottomSellers: 'Bottom sellers (last 5)',
    revenueByCategory: 'Revenue by category',
    categoryShare: 'Category share',
    revenueByDept: 'Revenue by department / tax type',
    tooltipRevenue: 'Revenue',
  },
  staffInsights: {
    title: 'Staff insights',
    subtitle: 'Hours, wages, and each person’s share of the tip pool.',
    loadFailed: 'Load failed',
    notConfigured: 'Not configured',
    couldntLoad: "Couldn't load staff insights",
    empty: 'No staff yet. Add people and their times on the Staff page.',
    noHours: 'No hours in this range, so the tip pool stays unsplit.',
    tipExplain: 'Tips from paid orders are split by hours. Wages use the rate in effect on each day.',
    chartTitle: 'Wage',
    chartTips: 'Tips',
    hours: 'Hours',
    wages: 'Wages',
    tipPool: 'Tip pool',
    totalPay: 'Total pay',
    colName: 'Name',
    colHours: 'Hours',
    colShare: 'Share of hours',
    colWage: 'Wages',
    colTip: 'Tip',
    colTotal: 'Total',
  },
  businessHealth: {
    title: 'Business health',
    subtitle: 'Profitability, break-even, and menu performance',
    monthAria: 'Month',
    loadFailed: 'Load failed',
    couldntLoad: "Couldn't load business health",
    profitable: 'Profitable this month',
    losing: 'Losing money this month',
    biggestCost: 'Biggest cost: {{label}} ({{amount}}, {{pct}} of revenue)',
    revenue: 'Revenue',
    grossMargin: 'Gross margin',
    netMargin: 'Net margin',
    covers: 'Covers',
    paidOrders: 'Paid orders',
    plTitle: 'P&L breakdown',
    helpRevenue: 'Revenue — total of paid order totals in this month (paid_at).',
    helpCogs:
      "Food cost (COGS) — ingredient cost of what was sold, line by line: each product's recipe, chosen pours/swaps from modifiers, and weighted-average ingredient prices.",
    helpGross:
      'Gross profit = revenue − COGS. Fixed costs come from your monthly entries plus drawer (petty cash) expenses from shifts. Net profit = gross profit − all fixed costs.',
    helpHow: 'How is {{title}} calculated?',
    lineRevenue: 'Revenue',
    lineCogs: '− Food cost (COGS)',
    lineGross: '= Gross profit',
    lineLabor: '− Labor',
    lineRent: '− Rent',
    lineUtilities: '− Utilities',
    lineDrawer: '− Drawer expenses',
    lineMarketing: '− Marketing',
    lineOther: '− Other fixed',
    lineNet: '= Net profit',
    breakEven: 'Break-even & runway',
    fixedCosts: 'Fixed costs / month',
    revenueNeeded: 'Revenue needed / day',
    coversNeeded: 'Covers needed / day',
    inventoryOnHand: 'Inventory on hand',
    inventoryDays: '~{{days}} days',
    cashBalance: 'Cash balance',
    cashRunway: 'Cash runway',
    cashRunwayValue: '~{{months}} months',
    profitableNote: 'Profitable — cash balance is growing if you retain earnings.',
    monthlyCosts: 'Monthly costs & cash balance',
    monthlyHint: 'Enter fixed costs for this month. Drawer expenses (petty cash) are pulled automatically from shifts.',
    cashOnHand: 'Cash on hand (֏)',
    catLabor: 'Labor / salaries',
    catRent: 'Rent',
    catUtilities: 'Utilities',
    catMarketing: 'Marketing',
    catOther: 'Other fixed',
    menuProfit: 'Menu profitability (by profit contribution)',
    colProduct: 'Product',
    colType: 'Type',
    colQty: 'Qty',
    colProfit: 'Profit',
    colMargin: 'Margin',
    menuMatrix: 'Menu matrix',
    considerRemoving: 'Consider removing:',
    star: 'Star',
    workhorse: 'Workhorse',
    puzzle: 'Puzzle',
    dog: 'Dog',
    starHint: 'Keep promoting — high volume and strong margin.',
    workhorseHint: 'Popular but thin margin — consider a small price increase.',
    puzzleHint: 'Good margin but low sales — promote or reposition.',
    dogHint: 'Low volume and low margin — consider removing.',
    popularity: 'Popularity',
    margin: 'Margin',
    revenueByHour: 'Revenue by hour',
    revenueByWeekday: 'Revenue by weekday',
    belowBreakEven: 'Days below {{amount}} revenue may not cover fixed costs.',
    costCogs: 'Food cost (COGS)',
    costLabor: 'Labor',
    costRent: 'Rent',
    costUtilities: 'Utilities',
    costDrawer: 'Drawer expenses',
    costMarketing: 'Marketing',
    costOther: 'Other fixed',
    ledgerCheck: 'Inventory ledger check: {{ledger}} vs order-line COGS {{cogs}} ({{pct}}% apart).',
    ledgerWarn:
      ' Large gap — often legacy deductions (e.g. after unit changes) or refunds in another month.',
    ledgerOk: ' Ledger and order-line COGS are aligned for this month.',
    helpLedger:
      'The inventory ledger check below compares this to physical stock deductions. Large gaps usually mean legacy data or unit migrations — not that COGS is wrong on the P&L line.',
    helpCogsExtra:
      'When available, uses cogs_amd frozen at order close; older lines are estimated from current recipes.',
    helpMenuAgg: 'One row per product, aggregating all paid order lines in this month.',
    helpMenuQty:
      'Qty — units sold. Profit = line revenue − line COGS (same logic as P&L food cost). Sorted by profit — highest contributors first.',
    helpMenuMargin:
      'Margin = profit ÷ revenue for that product. Type (Star / Workhorse / Puzzle / Dog) splits popularity vs margin at 50% each — menu-engineering quadrants.',
    helpMenuWine:
      'Wine and choice-based items use the pour actually sold (from order modifiers), not a theoretical average.',
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
  },
} as const;
